import SermonOutlines from "./SermonOutlines";

const Sermon = ({thisSermon}) => {
    return (
        <div className="row mb-30">
            <div className="col-lg-12">
                <h3 className="sermons-green-text text-uppercase font-weight-bolder big-spacing">{thisSermon.tagLine} - {thisSermon.speaker}</h3>
                <span className="sermons-date-text font-weight-bold increase-text">{thisSermon.dateGiven + ", Scripture: " + thisSermon.scripture + " (" + thisSermon.audioFile + ")"}</span>
                <br/>
                <audio className="audio-margin" controls>
                    <source src={"/site/media/sermons/" + thisSermon.audioFile} type="audio/mpeg"/>
                    Your browser does not support the audio element.
                </audio>
                <SermonOutlines thisSermon={thisSermon} />
            </div>
        </div>
    )
}
export default Sermon;